<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="processing...">
  </mat-progress-bar>
</section>

<section [hidden]="loading">
  <div fxLayout="row wrap" class="matero-row" *ngIf="housingUnitId > 0 && !authService.isReadOnly()">
    &nbsp;&nbsp;
    <button id="btnWaterSystem" mat-raised-button color="primary" title="Add Water System" (click)="add()" *ngIf="!authService.isReadOnly()"><mat-icon>add</mat-icon> Add Water System</button>
  </div>
  <br />

  <mat-card>
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
      <strong class="noMarginHeader">Water Systems ({{resultSize}})</strong>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <br /><br />
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> Id </th>
          <td mat-cell *matCellDef="let element">
            <a (click)="edit(element.id)" title="Edit {{element.id}}">{{element.id}}</a>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef> Comments </th>
          <td mat-cell *matCellDef="let element">
            <div style="white-space: pre-wrap">{{element.comments}}</div>
          </td>
        </ng-container>

        <!-- active Column -->
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef> Active </th>
          <td mat-cell *matCellDef="let element"> <span *ngIf="element.active">Yes</span> <span *ngIf="!element.active">No</span></td>
        </ng-container>

        <!-- updated Column -->
        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef> Last Updated </th>
          <td mat-cell *matCellDef="let element"> {{element.lastUpdated}} by {{element.lastUpdatedBy}}</td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <a href="javascript:void(0)" *ngIf="element.id > 0 && !authService.isReadOnly()" (click)="delete(element.id)" title="Delete Water System">
              <mat-icon>delete</mat-icon>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>


      <!--  
      <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <mat-row>Results ({{resultSize}})</mat-row>  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Water System Id</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span *ngIf="result.id > 0">
              <a (click)="edit(result.id)" title="Edit {{result.id}}">{{result.id}}</a>
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let result">
            {{result.Name}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Comment</mat-header-cell>
          <mat-cell *matCellDef="let result">
            <span style="white-space: pre-wrap">{{result.comment}}</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="updated">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Updated</mat-header-cell>
          <mat-cell *matCellDef="let result">
            {{result.lastUpdated}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
          <mat-cell *matCellDef="let result" fxFlex="10">
            <a href="javascript:void(0)" *ngIf="result.id > 0" (click)="delete(result.id)" title="Delete Water System">
              <mat-icon>delete</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
      </mat-table>
      <br />
    -->
    </div>
  </mat-card>
</section>